// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3yyPP","title":"styles_title__foQ46"};